<h3>Processing Queues</h3>
@if (sqsQueueSummary !== undefined) {
  <div>
    <table class="table table-bordered">
      <thead class="table-dark">
        <tr>
          <th>FILE QUEUE COUNT</th>
          <th>FILE PART QUEUE COUNT</th>
          <th>CLAIM QUEUE COUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{sqsQueueSummary.fullFileCount}}</td>
          <td>{{sqsQueueSummary.filePartsCount}}</td>
          <td>{{sqsQueueSummary.claimCount}}</td>
        </tr>
      </tbody>
    </table>
  </div>
} @else {
  <mat-spinner diameter="30" />
}
<h3>File Monitoring</h3>
<div class="mb-3">
  <form novalidate (ngSubmit)="onFormEnter($event)">
    <div class="row g-0 flex-row align-items-end">
      <div class="col-4">
        <div class="my-0 py-0 me-2">
          <label class="my-0"><strong>Partners</strong></label>
          <ng-select
            class="w-100"
            bindValue="value"
            bindLabel="display"
            name="partnerNames"
            placeholder="Filter by Partner"
            [multiple]="true"
            [items]="claimSourceOptions"
            (remove)="onPartnerNamesChange()"
            (change)="onPartnerNamesChange()"
            [(ngModel)]="formModel.selectedPartnerNames" />
        </div>
      </div>
      <div class="col-2">
        <div class="my-0 py-0 me-1">
          <label class="my-0"><strong>Filename</strong></label>
          <div class="input-group filename">
            <input
              [(ngModel)]="formModel.filename"
              name="filename"
              class="form-control"
              [ngClass]="{ 'has-value': hasFilename }"
              (keydown)="onFilenameKeyDown($event)"
              (keyup)="onFilenameKeyUp()"
              placeholder="my_referrals.csv"
              />
            @if (hasFilename) {
              <button class="btn btn-outline-secondary px-2" type="button" (click)="onClearFilenameClick()">
                <span aria-hidden="true" class="fs-5 lh-1">×</span>
              </button>
            }
          </div>
        </div>
      </div>
      <div class="col-2">
        <button class="btn btn-info ms-1 mt-0 clear-button" (click)="onClearAllClick($event)">Clear All</button>
      </div>
    </div>
  </form>
</div>
@if (!loading) {
  <div>
    @if (partnerFiles.length > 0) {
      <div>
        <app-pagination-header [paging]="paging" [label]="'partnerFiles'" (pageSizeChange)="onPageSizeChange($event)" />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th class="text-nowrap">ID</th>
              <th>CREATED</th>
              <th>PARTNER</th>
              <th class="text-nowrap">FILENAME</th>
              <th class="text-nowrap">ROWS</th>
              <th class="text-nowrap">ERRS</th>
            </tr>
          </thead>
          <tbody>
            @for (partnerFile of partnerFiles; track partnerFile) {
              <tr>
                <td>{{ partnerFile.id }}</td>
                <td>{{ partnerFile.createdAt | date: 'MM/dd/yyyy h:mm a' }}</td>
                <td>{{ partnerFile.partnerName }}</td>
                <td>{{ partnerFile.fileName }}</td>
                <td class="text-center">{{ partnerFile.totalRows }}</td>
                @if (partnerFile.errorCount > 0) {
                  <td class="text-center">
                    <a href="#" (click)="onDownloadErrorsClick($event, partnerFile)">
                      {{ partnerFile.errorCount }}
                    </a>
                  </td>
                }
                @if (partnerFile.errorCount === 0) {
                  <td class="text-center">
                    {{ partnerFile.errorCount }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </div>
    } @else {
      <section>
        <p>
          There are no partner files. Try modifying the filters or
          <strong><u><a href="#" (click)="onClearAllClick($event)">clearing them</a></u></strong>.
        </p>
      </section>
    }
  </div>
} @else {
  <mat-spinner diameter="30" />
}

